import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Servicio',
    href: '#servicio'
  }, {
    name: 'Curso',
    href: '#curso'
  }, {
    name: 'Sobre Avril',
    href: '#sobre-avril'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  return <div className="relative" data-id="element-47">
      {/* Header */}
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-ivory/95 backdrop-blur-sm shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-48">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-49">
          <div className="flex justify-between items-center" data-id="element-50">
            {/* Espacio vacío donde estaba el logo para mantener la alineación si es necesario, o simplemente dejar que el nav tome su lugar */}
            <div className="flex-shrink-0" data-id="element-51"></div>

            {/* Desktop Nav */}
            <nav className="hidden md:flex items-center space-x-8" data-id="element-52">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-brand-charcoal hover:text-brand-gold transition-colors" data-id="element-53">
                  {link.name}
                </a>)}
              <a href="#contacto" className="bg-brand-gold text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-brand-goldDark transition-colors shadow-sm" data-id="element-54">
                Reservar turno
              </a>
            </nav>

            {/* Mobile Menu Button */}
            <button className="md:hidden p-2 text-brand-charcoal" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-55">
              {isMobileMenuOpen ? <X size={24} data-id="element-56" /> : <Menu size={24} data-id="element-57" />}
            </button>
          </div>
        </div>

        {/* Mobile Nav */}
        {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-brand-ivory border-t border-brand-cream shadow-lg" data-id="element-58">
            <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-59">
              {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-3 text-base font-medium text-brand-charcoal hover:bg-brand-cream rounded-md" onClick={() => setIsMobileMenuOpen(false)} data-id="element-60">
                  {link.name}
                </a>)}
              <div className="pt-4 px-3" data-id="element-61">
                <a href="#contacto" className="block w-full text-center bg-brand-gold text-white px-6 py-3 rounded-full text-base font-medium hover:bg-brand-goldDark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-62">
                  Reservar turno
                </a>
              </div>
            </div>
          </div>}
      </header>

      {/* Hero Section */}
      <section className="relative pt-20 md:pt-0" data-id="element-63">
        <div className="w-full bg-brand-cream relative" data-id="element-64">
          <img src="https://cdn.magicpatterns.com/uploads/pSRKZjMY6g2CuiYm1BDCgy/banner_1.png" alt="Avril Balbis - Uñas que duran +21 días" className="w-full h-auto object-contain object-center" data-id="element-65" />
        </div>

        {/* Hero Subhead / Encabezado */}
        <div className="bg-brand-cream relative z-10 mt-6 md:-mt-16 mx-4 md:mx-auto max-w-4xl rounded-2xl shadow-xl p-6 sm:p-8 md:p-12 text-center" data-id="element-66">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-67">
            <h1 className="text-2xl md:text-4xl font-serif text-brand-charcoal leading-relaxed mb-6" data-id="element-68">
              La diferencia entre una manicurista que cobra $300 y una que cobra
              $1.200{' '}
              <span className="text-brand-gold italic" data-id="element-69">no es el talento.</span>
            </h1>
            <p className="text-lg md:text-xl text-brand-charcoal/80 font-medium mb-8" data-id="element-70">
              Es el método. Y hoy podés aprenderlo.
            </p>
            <div className="flex flex-col sm:flex-row justify-center items-center gap-4" data-id="element-71">
              <a href="#servicio" className="w-full sm:w-auto bg-brand-charcoal text-white px-8 py-3.5 rounded-full text-sm font-medium hover:bg-black transition-colors" data-id="element-72">
                Quiero uñas perfectas
              </a>
              <a href="#curso" className="w-full sm:w-auto bg-transparent border-2 border-brand-gold text-brand-gold px-8 py-3.5 rounded-full text-sm font-medium hover:bg-brand-gold hover:text-white transition-colors" data-id="element-73">
                Quiero aprender el método
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>;
}